import axios from "axios";
import React, { useState } from "react";
import { Form, Button, InputGroup, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import "../css/signin.css";
import "../css/LandingPage.css";

function UserSignup({ history }) {
  const [state, setState] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [accountType, setAccountType] = useState(false);
  const [loading, setLoading] = useState(false);
  const { register, errors } = useForm();

  const handleAccount = () => {
    setAccountType(!accountType);
  };

  // Condensing the useStates
  const handleChange = (event) => {
    event.persist();
    setState((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSignup = async (event) => {
    setLoading(true);

    const email = state.email;
    const password = state.password;
    const name = state.name;
    const account = accountType ? "Clinic" : "Client";
    try {
      event.preventDefault();
      const data = {
        name: name,
        password: password,
        email: email,
        account: account,
      };
      const res = await axios.post("/api/signup", data);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("name", data.name);
      localStorage.setItem("account", data.account);
      localStorage.setItem("email", data.email);
      localStorage.setItem("id", res.data.id);

      toast.success("successfully logged in", {
        position: "top-right",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      history.push("/");
    } catch (err) {
      console.error(err);
      toast.error("sorry something went wrong , try again later", {
        position: "top-right",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setLoading(false);
  };

  return (
    <div className="sign__container">
      <div className="signin">
        <Form className="signin__form" onSubmit={handleSignup}>
          <h4 className="text-center">
            {" "}
            <strong> Create your account </strong>
          </h4>
          <div className="mb-3 text-center">
            <h6>
              <strong>Select Account Type</strong>{" "}
            </h6>
            <div className="signin__selectUser">
              <Form.Check
                onChange={handleAccount}
                checked={!accountType}
                inline
                label="Client"
                type="radio"
                id="user"
                name="user"
              />
              <Form.Check
                onChange={handleAccount}
                checked={accountType}
                inline
                label="Clinic"
                type="radio"
                id="clinic"
                name="user"
              />
            </div>
          </div>
          <InputGroup controlid="formBasicEmail" className="mb-3">
            <InputGroup.Prepend>
              <InputGroup.Text style={{ width: "100px" }} id="basic-addon1">
                Name
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              value={state.name}
              onChange={handleChange}
              name="name"
              ref={register({ required: true })}
              type="text"
              placeholder="Enter name"
            />
          </InputGroup>
          {errors.name && (
            <span className="text-danger mb-2">This field is required</span>
          )}
          <InputGroup controlid="formBasicEmail" className="mb-3">
            <InputGroup.Prepend>
              <InputGroup.Text style={{ width: "100px" }} id="basic-addon1">
                Email
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              value={state.email}
              onChange={handleChange}
              name="email"
              ref={register({ required: true, pattern: "" })}
              type="email"
              placeholder="Enter email"
            />
          </InputGroup>
          {errors.email && (
            <span className="text-danger mb-2">Valid Email is required</span>
          )}
          <InputGroup controlid="formBasicPassword" className="mb-3">
            <InputGroup.Prepend>
              <InputGroup.Text style={{ width: "100px" }} id="basic-addon1">
                Password
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              value={state.password}
              onChange={handleChange}
              name="password"
              ref={register({ required: true, minLength: 6 })}
              type="password"
              placeholder="Password"
            />
          </InputGroup>
          {errors.password && (
            <span className="text-danger mb-5">
              Strong Password with at least 6 characters is required
            </span>
          )}
          <div className="form-group text-center">
            <label className="form-check-label" htmlFor="agreement">
              By signing up you are agreeing to our Terms and Conditions
            </label>
          </div>
          <Button
            disabled={loading}
            type="submit"
            className="w-100 primary-btn btn mt-5"
          >
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
            Submit
          </Button>
          <div className="signin-up-alts">
            <p>Already have an account?</p>
            <a href="/signin" className="d-block danger-link">
              Sign in Here
            </a>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default UserSignup;
